import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import StudentData from './StudentData';
import StudentProfile from './StudentProfile';
import StudentAttendance from './StudentAttendance';
import BulkUpload from './BulkUpload';
import StudentPromotion from './StudentPromotion';

interface SISModuleProps {
  domain: string;
  onBack: () => void;
}

const SISModule: React.FC<SISModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('students');

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/bulkupload')) setActiveTab('bulkupload');
    else if (path.includes('/profile')) setActiveTab('profile');
    else if (path.includes('/attendance')) setActiveTab('attendance');
    else if (path.includes('/promotion')) setActiveTab('promotion');
    else setActiveTab('students');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Student Information System</h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'students' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/sis')}
              >
                <i className="bi bi-people me-2"></i>Student Data
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'bulkupload' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/sis/bulkupload')}
              >
                <i className="bi bi-upload me-2"></i>Bulk Upload
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'profile' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/sis/profile')}
              >
                <i className="bi bi-person-badge me-2"></i>Update Profile
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'attendance' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/sis/attendance')}
              >
                <i className="bi bi-calendar-check me-2"></i>Attendance
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'promotion' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/sis/promotion')}
              >
                <i className="bi bi-arrow-up-circle me-2"></i>Student Promotion
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<StudentData domain={domain} />} />
          <Route path="bulkupload" element={<BulkUpload domain={domain} />} />
          <Route path="profile" element={<StudentProfile domain={domain} />} />
          <Route path="attendance" element={<StudentAttendance domain={domain} />} />
          <Route path="promotion" element={<StudentPromotion domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default SISModule;